import { BrowserRouter, Route, Routes } from 'react-router-dom';

import AdminApp from './admin/AdminApp';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import { LanguageProvider } from './i18n/LanguageProvider';
import AboutPage from './pages/AboutPage';
import CasesPage from './pages/CasesPage';
import ContactPage from './pages/ContactPage';
import HomePage from './pages/HomePage';
import InsightPage from './pages/InsightPage';
import InsightsPage from './pages/InsightsPage';
import NotFoundPage from './pages/NotFoundPage';
import ServicesPage from './pages/ServicesPage';

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Admin ligger utanför den publika layouten och har egen inloggning. */}
          <Route path="/cmsadminn1" element={<AdminApp />} />
          <Route element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="tjanster" element={<ServicesPage />} />
            <Route path="case" element={<CasesPage />} />
            <Route path="insights" element={<InsightsPage />} />
            <Route path="insights/:slug" element={<InsightPage />} />
            <Route path="om-oss" element={<AboutPage />} />
            <Route path="kontakt" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}
